<template>
  <div
    v-if="showDevWarning && devWarning"
    class="p-1 bg-nash-mustard600 font-semibold text-center print:hidden"
  >
    {{ devWarning }}
  </div>
  <div
    v-if="showInformationBanner && productWarningConfig?.message"
    :class="`flex justify-center p-2 ${productWarningConfig?.styles} font-semibold text-center print:hidden`"
  >
    <TIcon :icon="productWarningConfig?.icon" class="mx-1" />
    {{ productWarningConfig?.message }}
  </div>
</template>

<script lang="ts">
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'
import setup from './controller'

export default defineComponent({
  components: {
    TIcon,
  },
  props: {
    showDevWarning: {
      type: Boolean,
      default: true,
    },
  },
  setup,
})
</script>
